import { render, staticRenderFns } from "./downstat.vue?vue&type=template&id=a6052622&"
import script from "./downstat.vue?vue&type=script&lang=js&"
export * from "./downstat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports